import React from "react";
import Header from "../Home/Header/Header";

const AccountDeleteStep = () => {
  return (
    <div>
      <Header otherPage={true} title="Account Delete Step" />
      <div
        style={{
          padding: "60px 16px 16px 16px",
          fontFamily: "Arial, sans-serif",
          lineHeight: "1.6",
          color: "#333",
        }}
      >
        <h1
          style={{
            fontSize: "20px",
            fontWeight: "bold",
            marginBottom: "12px",
            color: "#1a73e8",
          }}
        >
          How to Delete Your Account
        </h1>
        <p style={{ fontSize: "14px", marginBottom: "16px" }}>
          Deleting your account will result in your mobile number, email
          address, and profile name being deleted from the platform and makes
          all other attributes related to your Optigo Admin App account
          anonymous, so it is no longer associated with your phone number.
        </p>
        <h2
          style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "8px" }}
        >
          Steps to Delete Your Account:
        </h2>
        <h3 style={{ fontSize: "14px", fontWeight: "bold", marginTop: "16px" }}>
          For iOS / Android app:
        </h3>
        <ol
          style={{ fontSize: "14px", marginLeft: "20px", marginBottom: "16px" }}
        >
          <li>Log in to your Optigo Admin App account.</li>
          <li>Go to the ‘Profile’ section on Top Right Corner.</li>
          <li>Select ‘Delete My Account’.</li>
          <li>Click on ‘Yes to Delete Account’.</li>
          <li>
            Your account deletion will be completed in a maximum of 30 days.
          </li>
        </ol>
        <h3 style={{ fontSize: "14px", fontWeight: "bold", marginTop: "16px" }}>
          For the Website:
        </h3>
        <ol
          style={{ fontSize: "14px", marginLeft: "20px", marginBottom: "16px" }}
        >
          <li>
            Log in to your Optigo Admin App account with your phone number,
            email address, and OTP.
          </li>
          <li>
            Contact us via the available options at the bottom of this page and
            submit your request.
          </li>
        </ol>
        <h2
          style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "8px" }}
        >
          Things to Note Before Deleting Your Account:
        </h2>
        <ul style={{ fontSize: "14px", marginLeft: "20px" }}>
          <li>Account deletion may take up to 30 days.</li>
          <li>Once your account is deleted, it cannot be recovered.</li>
        </ul>
      </div>
    </div>
  );
};

export default AccountDeleteStep;
